import { api } from '@admin/services/api';
import type { AdminMatchRoundsResponse } from '@games/word-clash/shared/types';

/**
 * Full round-by-round breakdown of a Word Clash match, including every answer
 * submission (#817 — moved out of the framework's services/matches). Separate
 * from the platform `getMatch(id)` so the detail page renders its header
 * quickly while the (potentially large) round payload streams in after.
 */
export async function getMatchRounds(
  id: string,
): Promise<AdminMatchRoundsResponse> {
  return api<AdminMatchRoundsResponse>(
    `/admin/matches/${encodeURIComponent(id)}/rounds`,
  );
}
